import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const asideSizes = {
  default: ['100%', '100%', '382px', '382px', '382px', '482px'],
  large: ['100%', '100%', '33.177083333vw', '33.177083333vw', '33.177083333vw', '33.177083333vw']
};
export default {
  overlay: (active: boolean, useCurtain: boolean | undefined) => ({
    background: useCurtain ? 'rgba(0,0,0,0.7)' : 'transparent',
    display: 'block',
    width: useCurtain ? '100%' : 'auto',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: theme.zIndex.aside,
    ...(active ? {
      opacity: 1,
      pointerEvents: 'auto'
    } : {
      opacity: 0,
      pointerEvents: 'none'
    }),
    ...reusables.mainTransition('opacity'),
    willChange: 'opacity'
  }),
  aside: (active: boolean, size: 'default' | 'large', overflowY: string = 'auto', overflowX: string = 'hidden') => ({
    maxWidth: asideSizes[size],
    background: theme.rawColors.neutralWhite,
    border: '0px solid rgba(25, 25, 25, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: theme.zIndex.documentHigh,
    maxHeight: '100%',
    overflowY: overflowY,
    overflowX: overflowX,
    right: '0',
    ...reusables.mainTransition('transform'),
    willChange: 'transform',
    borderLeftWidth: '1px',
    ...(active ? {
      transform: 'translateX(0px)'
    } : {
      transform: 'translateX(100%)'
    })
  }),
  asideContent: {
    padding: 0,
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  closeContainer: {
    width: '100%',
    display: 'flex',
    padding: '16px 24px 0px 16px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'stretch'
  }
};